import { useLocation, Navigate } from 'react-router-dom';
import AuthContext from '../contexts/auth';
import { useContext} from 'react';
import { useSelector } from 'react-redux';
import { rolesCodes } from '../constants/Roles';

export const RoleRoute = ({ children }) => {
  const roles = useSelector((state) => state.role);
  const datiUtente = useSelector((state) => state.presaVisione);
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const isAuthenticated = authContext.isLoggedIn;

  if (!isAuthenticated && location.pathname !== '/login') {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }
  if (!roles.selected && roles?.authorities?.length > 1 && location.pathname !== '/scelta-ruolo') {
    return <Navigate to='/scelta-ruolo' state={{ from: location }} replace />;
  }
  if (roles.selected && roles.selected === rolesCodes.cittadino && roles.authorities && !datiUtente.presaVisione && location.pathname !== '/presa-visione') {
    return <Navigate to='/presa-visione' state={{ from: location }} replace />;
  }
  if (roles.selected && roles.selected === rolesCodes.cittadino && roles.authorities && datiUtente.presaVisione && !datiUtente.datiUtente && location.pathname !== '/dati-utente') {
    return <Navigate to='/dati-utente' state={{ from: location }} replace />;
  }
  if (roles.selected && roles.selected === rolesCodes.cittadino && roles.authorities && datiUtente.presaVisione && datiUtente.datiUtente && location.pathname !== '/dashboard') {
    return <Navigate to='/dashboard' state={{ from: location }} replace />;
  }
  if (roles.selected && roles.authorities && roles.selected !== rolesCodes.cittadino && location.pathname !== '/home') {
    return <Navigate to='/home' state={{ from: location }} replace />;
  }
  return children;
};
